import { action } from '@ember/object';

import { ReportFragmentAction } from 'webapp/enums/enums';

import type { ReportFragmentActionData } from 'webapp/components/reports/editor-base';
import type { Args as BaseArgs } from 'webapp/components/reports/viewer/fragment/story-text';
import ReportsViewerFragmentStoryTextComponent from 'webapp/components/reports/viewer/fragment/story-text';

import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

interface Args extends BaseArgs {
	onFragmentChange: (
		fragment: ReportSlideFragment,
		action: ReportFragmentAction,
		data?: ReportFragmentActionData,
	) => Promise<unknown>;
}

export default class ReportsEditorFragmentStoryTextComponent extends ReportsViewerFragmentStoryTextComponent<Args> {
	override isEditable = true;

	@action
	override bindBlockChange() {
		const blockSetup = this.args.model.block?.blockSetup;
		if (blockSetup) {
			blockSetup.registerEvent(this.onFragmentChange);
		}
	}

	override willDestroy(): void {
		super.willDestroy();
		const blockSetup = this.args.model.block?.blockSetup;
		if (blockSetup) {
			blockSetup.unregisterEvent(this.onFragmentChange);
		}
	}

	@action
	onFragmentChange(data?: ReportFragmentActionData) {
		void this.args.onFragmentChange(this.args.model, ReportFragmentAction.CONTENT, data);
	}
}
